export default __webpack_public_path__ + "static/collins_dev_cv-9c029c9c50b8d3f8c22d81b262c5608d.pdf";